import React from 'react';
import {
  useListStatementsByUser,
  useListPayors,
  useListProvidersBySite,
  useListStatus,
  useListTariffs,
  useListSitesByOrganization,
} from 'api/resource';
import { useCurrentUserStore } from 'store/UserStore';
import { StatementManagement } from '..';
import { useProviderAllSites } from 'hooks/useProviderAllSites';
import { useIsProvider } from 'hooks/useIsProvider';

export const UserStatementManagement: React.FC = () => {
  const { id: userID, organizationID } = useCurrentUserStore();
  const isProvider = useIsProvider();
  const {
    isAllSites,
    providersResult: providersByUserResult,
    siteID,
  } = useProviderAllSites({ enabled: isProvider });

  const providersBySiteResult = useListProvidersBySite({
    siteID: Array.isArray(siteID) ? undefined : siteID,
  });
  const providers = isAllSites
    ? providersByUserResult.data || []
    : providersBySiteResult.data || [];

  const { data: payors = [], isLoading: isPayorsLoading } = useListPayors();

  const { data: statuses = [], isLoading: isStatusesLoading } = useListStatus(
    {}
  );

  const { data: tariffs = [], isLoading: isTariffsLoading } = useListTariffs(
    {}
  );

  const { data: sites = [], isLoading: isSitesLoading } =
    useListSitesByOrganization({
      orgID: organizationID,
    });

  const {
    data: statements = [],
    isLoading: loadingStatements,
    isError: isStatementsError,
    error: statementsError,
    isFetching: isStatementsFetching,
  } = useListStatementsByUser({
    userID,
    siteID,
  });
  const isLoading =
    loadingStatements ||
    isStatementsFetching ||
    isPayorsLoading ||
    isStatusesLoading ||
    isTariffsLoading ||
    isSitesLoading;
  const isError = isStatementsError;
  const errorMessage = statementsError?.message;

  return (
    <StatementManagement
      statements={statements}
      payors={payors}
      providers={providers}
      statuses={statuses}
      tariffs={tariffs}
      isLoading={isLoading}
      isError={isError}
      errorMessage={errorMessage}
      sites={sites}
    />
  );
};
